import { createSelector } from '@ngrx/store';
import { AppFeatures, IAppState } from '../app.state';
import { IArticlesState } from './articles.state';

export const getArticlesState = (state: IAppState) => state[AppFeatures.ARTICLES];
export const getArticles =
  createSelector(getArticlesState, (state: IArticlesState) => state.articles);
export const getAllArticlesById =
  createSelector(getArticlesState, (state: IArticlesState) => state.allArticlesById);
export const getArticleById = (articleId: string) => createSelector(getArticlesState, (state: IArticlesState) =>
  state?.articles?.find(a => a.id === articleId));
export const getAllArticlesByCode =
  createSelector(getArticlesState, (state: IArticlesState) => state.allArticlesByCode);
export const getArticlesForGestiune = createSelector(getArticlesState, (state: IArticlesState) => state.articlesForGestiune);
// export const getArticlesForGestiunePage = createSelector(getArticlesState, (state: IArticlesState) => state.articlesForGestiunePage);
// export const getArticlesForGestiunePageSize = createSelector(getArticlesState, (state: IArticlesState) => state.articlesForGestiunePageSize);
export const getArticlesForGestiuneIsLoading = createSelector(getArticlesState, (state: IArticlesState) => state.articlesForGestiuneLoading);

export const getArticlesPaginated = createSelector(getArticlesState, (state: IArticlesState) => state.articlesPaginated);
export const getArticlesPaginatedPage = createSelector(getArticlesState, (state: IArticlesState) => state.articlesPaginatedPage);
export const getArticlesPaginatedPageSize = createSelector(getArticlesState, (state: IArticlesState) => state.articlesPaginatedPageSize);
export const getArticlesPaginatedIsLoading = createSelector(getArticlesState, (state: IArticlesState) => state.articlesPaginatedLoading);

export const getArticlesForGestiuneConsumabile =
  createSelector(getArticlesState, (s: IArticlesState) => s.articlesForGestiuneConsumabile);
export const getArticlesForGestiuneConsumabileIsLoading =
  createSelector(getArticlesState, (s: IArticlesState) => s.articlesForGestiuneConsumabileLoading);
export const getArticlesForGestiuneConsumabilePage =
  createSelector(getArticlesState, (s: IArticlesState) => s.articlesForGestiuneConsumabilePage);
export const getArticlesForGestiuneConsumabilePageSize =
  createSelector(getArticlesState, (s: IArticlesState) => s.articlesForGestiuneConsumabilePageSize);
export const getArticlesForGestiuneConsumabileSearch =
  createSelector(getArticlesState, (s: IArticlesState) => s.articlesForGestiuneConsumabileSearch);
export const getArticlesWithGestiune = createSelector(getArticlesState, (state: IArticlesState) => state.articlesWithGestiune);
export const getArticlesWithGestiuneIsLoading = createSelector(getArticlesState, (state: IArticlesState) => state.articlesWithGestiuneLoading);
